import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ApplicationRoles } from '../components/users/user-roles';
import { Provinces } from '../components/global/province';

export interface AboutUsProvinceOption {
  id: Provinces;
  abbreviation: string;
  labelKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class AboutUsService {
  readonly publicProvinceOptions: AboutUsProvinceOption[] = [
    { id: Provinces.BritishColumbia, abbreviation: 'BC', labelKey: 'aboutUsProvinceBC' },
    { id: Provinces.Ontario, abbreviation: 'ON', labelKey: 'aboutUsProvinceON' },
    { id: Provinces.Quebec, abbreviation: 'QC', labelKey: 'aboutUsProvinceQC' },
    { id: Provinces.Manitoba, abbreviation: 'MB', labelKey: 'aboutUsProvinceMB' },
    { id: Provinces.NewBrunswick, abbreviation: 'NB', labelKey: 'aboutUsProvinceNB' },
  ];

  constructor(private _authservice: AuthService) { }

  /** i18n key for HTML body; empty string when this page does not apply to the role. */
  getAboutUsContentTranslationKey(): string {
    const userData = this._authservice.getUserLoginData();

    if (!userData.isParticipant) {
      return this.getContentTranslationKeyForProvince(
        this.resolveProvinceForAboutUs(userData.provinceId)
      );
    }

    const activeRole = this._authservice.getAccessControl().participantLastActiveRole;
    if (
      activeRole !== ApplicationRoles.BB_CoachedParticipant &&
      activeRole !== ApplicationRoles.BB_SelfGuidedParticipant
    ) {
      return '';
    }

    return this.getContentTranslationKeyForProvince(
      this.resolveProvinceForAboutUs(userData.provinceId)
    );
  }

  resolveProvinceForAboutUs(provinceId: number): Provinces {
    if (provinceId === Provinces.Other) {
      return Provinces.Other;
    }

    const supportedProvince = this.publicProvinceOptions.find((option) => option.id === provinceId);
    return supportedProvince?.id ?? Provinces.BritishColumbia;
  }

  getContentTranslationKeyForProvince(provinceId: number): string {
    switch (provinceId) {
      case Provinces.BritishColumbia:
        return 'aboutUsContentBC';
      case Provinces.Ontario:
        return 'aboutUsContentON';
      case Provinces.Quebec:
        return 'aboutUsContentQC';
      case Provinces.Manitoba:
        return 'aboutUsContentMB';
      case Provinces.NewBrunswick:
        return 'aboutUsContentNB';
      case Provinces.Other:
      default:
        return 'aboutUsContentDefault';
    }
  }
}
